import React, { useState, useEffect, useContext, useRef } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  getUser
} from '../../../store/alpha'
import { 
  getProjectList, 
  fetchProjectList,
  getTrainingClassList, 
  fetchTrainingClassList,
} from '../../../store/client'

import Button from '../../../shared/ui/Button'
import Link from '../../../shared/ui/Link'
import Panel from '../../../shared/ui/Panel'
import TableData from '../../../shared/ui/TableData'
import StatusLabel from '../../../shared/ui/StatusLabel'
import {capitalize} from '../../../shared/utilities/helpers'
import { NavigationContext } from '../../../shared/ui/NavigationController'
import SliderBox from '../../../shared/ui/SliderBox'

import TrainingClassCard from '../views/TrainingClassCard'
import ProjectFormView from '../views/ProjectFormView'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import DetailView from '../../../shared/ui/DetailView'

const styles = theme => ({
  root: {
    // maxWidth: '720px',
    position: 'relative',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  section: {
    position:'relative'
  },
  sectionHeader: {    
  },
  sectionTitle: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: 800,
  },
  sectionTitle2: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 800,
    //color: '#888'
  },
  sectionSubtitle: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 400,
    color: '#888'
  },
  cardListContainer: {
    width: '100%',
    width: `calc(100% + ${theme.spacing(2)}px)`,
    position: 'relative',
    overflow: 'hidden',
    margin: theme.spacing(-2),
    padding: theme.spacing(2)
  },
  cardRow: {
    display: 'table-row',
  },
  cardItemContainer: {
    minWidth: '240px',
    display: 'table-cell',
  },
  navigationSlider: {
    position: 'absolute',
    top: 0,
    right: 0
  }
})

const OrderTable = ({ theme, classes, rows }) => {
  const navigationContext = useContext(NavigationContext)
  
  const statusColor = {
    'Invite Sent': '#ffaa00',
    'Waiting for Proposal': '#0000cc',
    'Waiting for Revision': '#0000cc',
    'Proposal Received': '#00aa00',
    'Completed': '#000000',
    'Canceled': '#aaaaaa',
  }
  
  const columns = [
    { key: 'project_name', label: 'Course Name', variant: 'title' },
    { key: 'project_detail', label: 'Detail' },
    { key: 'submitted_at', label: 'Submitted'},
    { key: 'status', label: 'Status', wordWrap: false },
    // { key: 'training_provider', label: 'Training Provider'}
  ]     

  const getCellValue = (row, column) => {
    if (column.key == 'project_name') {
      if (row.course)
        return row.course.name
      else
        return `${row.title} (Custom Course)`      
    } else if(column.key == 'project_detail') {
        return row['delivery_method'] !== 'online' ? capitalize(row['delivery_method']) + ' Class' : capitalize(row['delivery_method']) + ' Class via '+row['delivery_app'] 
    } else if(column.key == 'customer_type') {
        return row['customer_type'] === 'public' ? "Public Class" : "Private Class"
    } else if (
        column.key === 'submitted_at' ||
        column.key === 'canceled_at' ||
        column.key === 'created_at' ||        
        column.key === 'updated_at'        
      ) {
        return row[column.key] ? moment(row[column.key]).fromNow() : '-'
    } else if (column.key == 'training_provider') {
        if (row.customer_type === 'public')
            return row.provider.name
        else if (row.selected_proposal)
            return row.selected_proposal.provider.name
            
        return (
            <Box>
                {row.providers.map(items =>
                  <Typography variant='body1'>
                      {items.name} (<b>{ items.provider_status })</b>
                  </Typography>  
                )}
            </Box>
        )
    } else if (column.key == 'status') {
      return (
        <StatusLabel
          color={statusColor[row.status] || '#555'}
          >
          { row.status }
        </StatusLabel> 
      )      
    }
  
    return row[column.key]
  }
  
  const getCellSecondaryValue = (row, column) => {
    if (column.key == 'project_name')
      return row.project_no ? row.project_no : ''
    else if(column.key == 'project_detail')
      return moment(row.training_date).format('DD MMM YYYY') + ', ' + row.participant_count +' pax'
  } 
  
  const showProjectDetail = (row) => {
    navigationContext.openLink(`/company/order/view/${row.uid}`)
  }
  
  return (
    <TableData
      columns={columns}
      rows={rows}
      getCellValue={getCellValue}
      getCellSecondaryValue={getCellSecondaryValue}
      onRowClick={(row) => showProjectDetail(row)}
      />    
  )
}

const Section = ({ theme, classes, variant, children, ...props}) => {
  
  const { title, subtitle, gutterBottom } = props
  
  return (
    <Box mb={ gutterBottom ? 4 : 0 }
      className={classes.section}
      >
      { (title || subtitle) &&
        <Box 
          className={classes.sectionHeader}>
          { title &&
            <Typography 
              component={variant==='subsection' ? 'h2' : 'h1'}
              className={variant==='subsection' ? classes.sectionTitle2 : classes.sectionTitle}
            >
              { title }
            </Typography>
          }
          { subtitle &&
            <Typography 
              component='h4'
              className={classes.sectionSubtitle}
            >
              { subtitle }
            </Typography>
          }
        </Box>
      }
      <Box mt={2}>
        { children }
      </Box>
    </Box>
  )
}

const TodayViewController = ({ theme, classes, ...props }) => {  
  const navigationContext = useContext(NavigationContext)
  
  const { fetchProjectList, fetchTrainingClassList } = props
  const { user, projectList, trainingClassList } = props

  const [openDialog, setOpenDialog] = useState(false)

  useEffect(() => {
    fetchTrainingClassList()
    fetchProjectList()
  }, [])
  
  let today = new Date()
  let hour = today.getHours()
  const greeting = hour < 12 ? "Good morning" : (
      hour < 18 ? "Good afternoon" : "Good evening"
    )      
  
  useEffect(() => {
  }, [])  
  
  let mainSections = []
  
  let upcomingClasses = trainingClassList.lastFetched && trainingClassList.data.records
  
  mainSections.push(
    <Section theme={theme} classes={classes}  
      title={"Today at " + user.companyInfo.name }
      subtitle={ moment(today).format("dddd, DD MMMM") }
      >
      <Panel>
        <Typography variant='h6'>
          { greeting },
          &nbsp;
          <span style={{ fontWeight: 400 }}>
            { user.userInfo.first_name} { user.userInfo.last_name}
          </span>
        </Typography>
        
        { trainingClassList.isFetching &&
          <Box display='flex' justifyContent='center' style={{ padding: theme.spacing(2) }}>
            <CircularProgress size='1.5rem' disableShrink={true} />        
          </Box>
        }

        { upcomingClasses && upcomingClasses.length > 0 &&
          <Typography variant="body1" gutterBottom>
            You have { upcomingClasses.length } upcoming classes
          </Typography>
        }         

        { upcomingClasses && upcomingClasses.length <= 0 &&
          <Typography>
            You have no upcoming classes
          </Typography>
        }            
      </Panel>
    </Section>
  )
  
  if (upcomingClasses && upcomingClasses.length > 0) {
    mainSections.push(
      <Section theme={theme} classes={classes}  
        variant="subsection"      
        title="Upcoming Classes"
        >

        { upcomingClasses.length >= 3 &&
          <SliderBox slidesToShow={3}>
            { upcomingClasses.map(c =>
                <div>
                  <TrainingClassCard
                    item={c}
                    linkTo={`/company/trainingclass/view/${c.uid}`}
                  />                
                </div>
              )
            }
          </SliderBox>
        }

        { upcomingClasses.length < 3 &&
          <div className={classes.cardListContainer}>
            <div className={classes.cardRow}>
            { upcomingClasses.map(c =>
                <div className={classes.cardItemContainer}>
                  <TrainingClassCard
                    item={c}
                    linkTo={`/company/trainingclass/view/${c.uid}`}
                  />                
                </div>
              )
              .reduce((p, n) => p ?
                [...p, <Box ml={2} />, n]
                : [n], null
              )
            }
            </div>
          </div>
        }
        
        <Box mt={2} display='flex' justifyContent='center'>
          <Button component={Link} to="/company/trainingclass">
            View All
          </Button>
        </Box>        
      </Section>    
    )
  }
  
  let recentProjects = projectList.lastFetched && 
    projectList.data.records.filter(p => (
      p.submitted_at && !p.canceled_at && !p.selected_proposal
    ))
  if (recentProjects && recentProjects.length > 5)
    recentProjects.splice(5, recentProjects.length-5)
  
  mainSections.push(
    <Section theme={theme} classes={classes}
      variant="subsection"
      title="Order On Progress"
      >
      { projectList.isFetching &&
        <Box display='flex' justifyContent='center' style={{ padding: theme.spacing(2) }}>
          <CircularProgress size='1.5rem' disableShrink={true} />        
        </Box>
      }
      
      { projectList.lastFetched &&      
        <Panel>
          
          { recentProjects && recentProjects.length > 0 &&
            <>
              <OrderTable theme={theme} classes={classes}
                rows={recentProjects}
                />
              <Box mt={1} display='flex' justifyContent='center'>
                <Button component={Link} to="/company/order">
                  View All
                </Button>
              </Box>
            </>
          }

          { recentProjects && recentProjects.length <= 0 &&
            <Typography>
              You have no project on progress
            </Typography>
          }      

        </Panel>
      }
    </Section>    
  )
  

  mainSections.push(
    <Section theme={theme} classes={classes}  
      title="New Order"
      >
      <Panel>
        <Typography variant='h6' gutterBottom>
          Order training classes for your employees.
        </Typography>
        <Box mt={3} mb={3} display='flex'>        
          <Box flexGrow={1}>
            <Button variant='contained'
              component={Link}
              to="/"
              fullWidth
              >
              Browse Courses
            </Button>
          </Box>
          <Box width={theme.spacing(2)} />
          <Box flexGrow={1}>
            <Button variant='contained'            
              fullWidth
              onClick={() => setOpenDialog(true)}
              >
              Order Custom Course
            </Button>
          </Box>          
        </Box>
      </Panel>
    </Section>
  )          
  
  return (
    <div className={classes.root}>
      <DetailView
        sideContent={
          <Box />
        }>
        { mainSections.reduce((p, n) => p ?
          [...p, <Box mt={4}/>, n] 
          : [n], null)
        }
      </DetailView>

      { openDialog &&
        <ProjectFormView 
          showDialog={true}
          onClose={() => setOpenDialog(false)}
          type={'custom'}
        />
        }
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: getUser(state),    
    projectList: getProjectList(state),
    trainingClassList: getTrainingClassList(state)  
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchProjectList: () => {
      dispatch(fetchProjectList(true))
    },
    fetchTrainingClassList: () => {
      dispatch(fetchTrainingClassList(true))      
    },        
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(TodayViewController)
)
